import { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { BsEnvelopePaper, BsTelephone, BsGeoAlt } from 'react-icons/bs';
import { submitContact } from '../../apis/contact';
import './contactus.css';

export const Contactus = () => {
  const [focused, setFocused] = useState('');
  const [form, setForm]       = useState({ name: '', phone: '', email: '', message: '' });
  const [status, setStatus]   = useState(null); // 'sending' | 'success' | 'error'

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await submitContact(form);
      if (res.success) {
        setStatus('success');
        setForm({ name: '', phone: '', email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-glow" />

      <Container className="position-relative">
        {/* Header */}
        <Row className="justify-content-center text-center mb-5">
          <Col xs={12} md={7}>
            <span className="contact-badge">Get In Touch</span>
            <h2 className="contact-heading">Let’s Grow Your<br /><span className="contact-highlight">Business Online</span></h2>
            <p className="contact-sub">Looking to scale your business with digital marketing? Fill out the form and we’ll get back to you shortly.</p>
          </Col>
        </Row>

        <Row className="justify-content-center g-5 align-items-start">

          {/* Left info panel */}
          <Col xs={12} lg={4}>
            <div className="contact-info-panel">
              <div className="info-item">
                <div className="info-icon"><BsTelephone /></div>
                <div>
                  <p className="info-label">Call Us</p>
                  <p className="info-value">+91 97915 09915</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon"><BsEnvelopePaper /></div>
                <div>
                  <p className="info-label">Email Us</p>
                  <p className="info-value">jsrdigimarketing@gmail.com</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon"><BsGeoAlt /></div>
                <div>
                  <p className="info-label">Visit Us</p>
                  <p className="info-value">Royapettah, Chennai, <br/> Tamil Nadu - 600 014</p>
                </div>
              </div>
              {/* <div className="info-divider" /> */}
            </div>
          </Col>

          {/* Right form */}
          <Col xs={12} lg={7}>
            <div className="contact-form-card">
              <Form onSubmit={handleSubmit}>
                <Row className="g-4">

                  <Col xs={12} md={6}>
                    <div className={`float-field ${focused === 'name' ? 'active' : ''}`}>
                      <Form.Control
                        type="text" name="name" value={form.name}
                        placeholder="Your Name" className="contact-input"
                        onChange={handle}
                        onFocus={() => setFocused('name')}
                        onBlur={() => setFocused('')}
                        required
                      />
                      <span className="field-line" />
                    </div>
                  </Col>

                  <Col xs={12} md={6}>
                    <div className={`float-field ${focused === 'mobile' ? 'active' : ''}`}>
                      <Form.Control
                        type="tel" name="phone" value={form.phone}
                        placeholder="Mobile Number" className="contact-input"
                        onChange={handle}
                        onFocus={() => setFocused('mobile')}
                        onBlur={() => setFocused('')}
                      />
                      <span className="field-line" />
                    </div>
                  </Col>

                  <Col xs={12}>
                    <div className={`float-field ${focused === 'email' ? 'active' : ''}`}>
                      <Form.Control
                        type="email" name="email" value={form.email}
                        placeholder="Email Address" className="contact-input"
                        onChange={handle}
                        onFocus={() => setFocused('email')}
                        onBlur={() => setFocused('')}
                        required
                      />
                      <span className="field-line" />
                    </div>
                  </Col>

                  <Col xs={12}>
                    <div className={`float-field ${focused === 'about' ? 'active' : ''}`}>
                      <Form.Control
                        as="textarea" rows={5} name="message" value={form.message}
                        placeholder="Tell us about your project..."
                        className="contact-input contact-textarea"
                        onChange={handle}
                        onFocus={() => setFocused('about')}
                        onBlur={() => setFocused('')}
                        required
                      />
                      <span className="field-line" />
                    </div>
                  </Col>

                  <Col xs={12}>
                    {status === 'success' && (
                      <p style={{ color: '#96ff00', marginBottom: '12px', fontSize: '0.9rem' }}>
                        ✓ Message sent! We'll get back to you within 24 hours.
                      </p>
                    )}
                    {status === 'error' && (
                      <p style={{ color: '#ff4d4d', marginBottom: '12px', fontSize: '0.9rem' }}>
                        Something went wrong. Please try again.
                      </p>
                    )}
                    <Button type="submit" className="contact-submit" disabled={status === 'sending'}>
                      <span>{status === 'sending' ? 'Sending...' : 'Send Message'}</span>
                      <span className="submit-arrow">→</span>
                    </Button>
                  </Col>

                </Row>
              </Form>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};
